import React, { useEffect, useState, useRef } from "react";
import { Navbar, Nav, Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import logoDark from "../assets/images/logo-dark-theme.png";
import logoLight from "../assets/images/logo-light-theme.png";
const Header = () => {
  const [activeItem, setActiveItem] = useState("Home");
  const [navClass, setNavClass] = useState("");


  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);
  }, []);

  function scrollNavigation() {
    var scrollUp = document.documentElement.scrollTop;
    if (scrollUp > 50) {
      setNavClass("nav-sticky");
    } else {
      setNavClass("");
    }
  }

  // toggle

  const navMenuRef = useRef(null);
  const toggleNavMenu = () => {
    navMenuRef.current.classList.toggle("collapse");
  };

  return (
    <>
      <div
        data-bs-spy="scroll"
        data-bs-target="#navbar"
        data-bs-offset="61"
        data-bs-smooth-scroll="true"
        className="scrollspy-example-2"
      >
        <section className="tagline d-none d-md-block">
          <Container fluid>
            <Row className="align-items-center">
              <Col md={6}>
                <div className="d-flex">
                  <div className="email ms-3">
                    <Link to="mailto:#" className="text-dark">
                      <i className="mdi mdi-email-open-outline"></i>{" "}
                      info@wolbee.com
                    </Link>
                  </div>
                </div>
              </Col>
              {/* <Col md={6}>
                <ul className="top_socials d-flex list-unstyled justify-content-end mb-0">
                  <li className="entry">
                    <Link to="#">
                      <i className="bx bxl-facebook-circle"></i>
                    </Link>
                  </li>
                  <li className="entry">
                    <Link to="#">
                      <i className="bx bxl-instagram"></i>
                    </Link>
                  </li>
                </ul>
              </Col> */}
            </Row>
            <div className="clear"></div>
          </Container>
        </section>

        <Navbar
          expand="lg"
          fixed="top"
          className={`navbar-custom sticky sticky-light ${navClass}`}
          id="navbar"
        >
          <Container fluid>
            <Navbar.Brand className="logo text-uppercase">
              <img src={logoDark} className="logo-light" alt="" height="60" />
              <img src={logoLight} className="logo-dark" alt="" height="60" />
            </Navbar.Brand>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={toggleNavMenu}
            >
              <span className="mdi mdi-menu"></span>
            </button>
            <div
              ref={navMenuRef}
              className="collapse navbar-collapse"
              id="navbarCollapse"
            >
              <ul className="navbar-nav ms-auto" id="navbar-navlist">
                <li
                  className={activeItem === "Home" ? "active" : "nav-item"}
                  onClick={() => setActiveItem("Home")}
                >
                  <Nav.Link href="#home">Home</Nav.Link>
                </li>
                <li
                  className={activeItem === "About Us" ? "active" : "nav-item"}
                  onClick={() => setActiveItem("About Us")}
                >
                  <Nav.Link href="#about">About Us</Nav.Link>
                </li>
                <li
                  className={activeItem === "Features" ? "active" : "nav-item"}
                  onClick={() => setActiveItem("Features")}
                >
                  <Nav.Link href="#features">Features</Nav.Link>
                </li>
                <li
                  className={
                    activeItem === "How It Works" ? "active" : "nav-item"
                  }
                  onClick={() => setActiveItem("How It Works")}
                >
                  <Nav.Link href="#how-it-works">How It Works</Nav.Link>
                </li>
                <li
                  className={activeItem === "Benefits" ? "active" : "nav-item"}
                  onClick={() => setActiveItem("Benefits")}
                >
                  <Nav.Link href="#benefits">Benefits</Nav.Link>
                </li>

                {/* <li
                  className={
                    activeItem === "Application" ? "active" : "nav-item"
                  }
                  onClick={() => setActiveItem("Application")}
                >
                  <Nav.Link href="#app">Application</Nav.Link>
                </li>
               */}
                <li
                  className={activeItem === "Contact" ? "active" : "nav-item"}
                  onClick={() => setActiveItem("Contact")}
                >
                  <Nav.Link href="#contact">Contact</Nav.Link>
                </li>
              </ul>
              <div className="ms-auto">
                {/* <Link
                  to={`${process.env.REACT_APP_DEV_URI}`}
                  className="btn bg-gradiant"
                >
                  Login
                </Link> */}
              </div>
            </div>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default Header;
